module.exports = __webpack_public_path__ + "img/HeaderRow2Placeholder.548b2bfa.svg";